export const facebookCacheStaleTime = 60 * 60 * 1000; // 1 hour in milliseconds
